import(/* webpackMode: "eager" */ "/home/interim/frontend/node_modules/next/dist/client/link.js");
